import { render, staticRenderFns } from "./Actives.vue?vue&type=template&id=4db1e70e"
import script from "./Actives.vue?vue&type=script&lang=js"
export * from "./Actives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports